export const selectModalState = (state) => state.modalContainer || {};
